const { ACTION_TYPES } = require('../reducers/error.reducer');

const errorMiddleware = store => next => action => {
  try {
    return next(action);
  } catch (error) {
    return store.dispatch({
      type: ACTION_TYPES.ERROR,
      payload: error,
    });
  }
};

module.exports = errorMiddleware;
